import React, {useRef} from "react";
import {Breadcrumbs} from "../features/breadcrumbs";
import {useTranslation} from "react-i18next";
import {useDirectProjectAccessDataContext} from "../providers/DirectProjectAccessDataProvider";
import {Link} from "react-router-dom";
import Button from "../components/ui/Button";
import SwitchComponent from "../components/ui/Switch/SwitchComponent";
import "./navigationHeader.scss"
import {IconSettings} from "../components/icons/IconSettings";
import {paths} from "../features/navigator";
import {getNewViewUrl, MANUAL_VIEW_PARAM} from "../utils/NewViewUtils";

type NavigationHeaderConfig = {
	saveAndFinishButtonVisibility: "visible" | "hidden"
}

const defaultConfig: NavigationHeaderConfig = {
	saveAndFinishButtonVisibility: "visible"
}

const NavigationHeader = function({children, config = defaultConfig}: {
	children?: React.ReactNode
	config?: NavigationHeaderConfig
}) {
	const {t} = useTranslation();
	const {isProjectDirectAccess, redirectToTheSimpro} = useDirectProjectAccessDataContext();
	const isSwitchingView = useRef(false);

	// SwitchComponent reports a change from both its onChange and onClick handlers; navigate once.
	const switchToNewView = () => {
		if (isSwitchingView.current) return;
		isSwitchingView.current = true;
		window.location.href = `${getNewViewUrl()}?${MANUAL_VIEW_PARAM}=1`;
		// Re-arm in the next task so a navigation cancelled by a beforeunload prompt doesn't leave the toggle dead.
		setTimeout(() => {
			isSwitchingView.current = false;
		}, 0);
	};

	return (
		<div className="navigation-header">
			<Breadcrumbs/>
			<div className="navigation-header_actions">
				<label className="navigation-header_view-toggle">
					<span>{t("newView.buttonLabel")}</span>
					<SwitchComponent checked={false} onSwitch={switchToNewView}/>
				</label>
				<Link to={paths.settings}>
					<Button icon={<IconSettings/>} label={t("settings.buttonLabel")} variant={"optional"}/>
				</Link>
				{children}
				{isProjectDirectAccess && config.saveAndFinishButtonVisibility === "visible"
					? <Button
						variant={"primary"}
						label={t("common.buttons.saveAndFinish")}
						onClick={redirectToTheSimpro}
					/> : null}
			</div>
		</div>
	)
}

export {NavigationHeader}